import React, { useEffect, useRef, useState } from 'react';
import { getDocument, GlobalWorkerOptions, version } from 'pdfjs-dist';

GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${version}/build/pdf.worker.min.mjs`;

const pdfCache = new Map();

const getPdfDocument = (pdfUrl) => {
  if (!pdfCache.has(pdfUrl)) {
    pdfCache.set(pdfUrl, getDocument({ url: pdfUrl }).promise);
  }
  return pdfCache.get(pdfUrl);
};

const PdfSlide = ({ pdfUrl, pageNumber = 1, scale = 1, className = '' }) => {
  const canvasRef = useRef(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const renderPage = async () => {
      if (!pdfUrl || !pageNumber) return;
      try {
        const pdf = await getPdfDocument(pdfUrl);
        if (cancelled) return;
        const page = await pdf.getPage(pageNumber);
        const viewport = page.getViewport({ scale });
        const canvas = canvasRef.current;
        if (!canvas) return;
        const context = canvas.getContext('2d');
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        await page.render({ canvasContext: context, viewport, background: 'white' }).promise;
        if (!cancelled) setError(null);
      } catch (err) {
        if (!cancelled) setError('Failed to render PDF');
      }
    };

    renderPage();
    return () => {
      cancelled = true;
    };
  }, [pdfUrl, pageNumber, scale]);

  return (
    <div className={`flex items-center justify-center ${className}`}>
      {error ? (
        <div className="text-xs text-red-400">{error}</div>
      ) : (
        <canvas ref={canvasRef} style={{ maxWidth: '100%', maxHeight: '100%' }} />
      )}
    </div>
  );
};

export default PdfSlide;
